import { Form, Button } from "antd";
import OtpInput from "react-otp-input";
import { FaArrowRight } from "react-icons/fa6";

const RegisterStepOtp = ({
  otp,
  setOtp,
  timeLeft,
  onResend,
  onVerify,
  onEditPhone,
}) => (
  <>
    <h2 className="second-title">ওটিপি দাও</h2>
    <Form layout="vertical" onFinish={onVerify}>
      <Form.Item>
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={4}
          renderInput={(props) => <input {...props} />}
          inputStyle={{
            width: "40px",
            height: "40px",
            fontSize: "16px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            textAlign: "center",
            color: '#0091EA',
          }}
        
          containerStyle={{ justifyContent: "center", gap: "8px" }}
        />
      </Form.Item>

      <div className="text-center !text-[#616161] mt-2 text-sm w-fit mx-auto bg-[#F3F5F6] py-1 px-3 rounded-lg">
        {timeLeft > 0 ? (
          <span>
            পুনরায় পাঠাও {Math.floor(timeLeft / 60)}:
            {String(timeLeft % 60).padStart(2, "0")}
          </span>
        ) : (
          <Button type="link" onClick={onResend} className="p-0">
            আবার ওটিপি পাঠাও
          </Button>
        )}
      </div>

      <a
        onClick={onEditPhone}
        className="!text-primary-text-4 py-1 px-3 rounded-lg border border-primary-text-4 block w-fit mx-auto sm:mt-4 mt-3 sm:mb-6 mb-4"
      >
        নাম্বার পরিবর্তন
      </a>

      <Button
        type="primary"
        htmlType="submit"
        size="large"
        className="login-regictation-submit-btn mb-0"
        disabled={otp.length !== 4}
      >
        পরবর্তী ধাপ <FaArrowRight />
      </Button>
    </Form>
  </>
);

export default RegisterStepOtp;
